import "../static/Section8.css";

export default function Section8() {
  return (
    <section className="section8">
      <div className="section8container">
        <h2>Curious Minds Wants to Know</h2>
        <div className="faqs">
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
          <div className="faq">
            <a href="#">
              <span className="faqText">Accordion - FAQs</span>
              <span className="caret caretbg">^</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
